import { AxiosResponse } from 'axios';
import api from "__application-api__";

export default async ({ mapTranslateId }: { mapTranslateId: string }): Promise<AxiosResponse> => {
	return await api.EDITOR.mapDelete({ mapTranslateId });
}
